namespace Matrix.Data {
    export interface TestResultMuteForm {
        TestCode: Serenity.StringEditor;
        MuteUntil: Serenity.DateEditor;
        Comment: Serenity.TextAreaEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class TestResultMuteForm extends Serenity.PrefixedContext {
        static formKey = 'Data.TestResultMute';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TestResultMuteForm.init)  {
                TestResultMuteForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.TextAreaEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(TestResultMuteForm, [
                    'TestCode', w0,
                    'MuteUntil', w1,
                    'Comment', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4
                ]);
            }
        }
    }
}
